const STAGE_RANK = { reading: 1, drafting: 2 };
function draftStage(progress) {
    switch (progress?.stage) {
        case 'GENERATE_STAGE_MODEL_STARTED':
        case 'GENERATE_STAGE_MODEL_WORKING':
            return 'reading';
        case 'GENERATE_STAGE_MODEL_DONE':
            return 'drafting';
        default:
            return undefined;
    }
}
/**
 * A terminal failure of the generation stream. `reason` is the typed `errorReason`; `message` is
 * the server's diagnostic text and is NOT user copy. A missing `errorReason` (legacy chunk, the
 * wire may omit it) is UNSPECIFIED.
 */
export class GenerateError extends Error {
    reason;
    constructor(message, reason) {
        super(message);
        this.name = 'GenerateError';
        this.reason = reason ?? 'GENERATE_ERROR_REASON_UNSPECIFIED';
    }
}
export function generateErrorCopyKey(reason) {
    switch (reason) {
        case 'GENERATE_ERROR_REASON_MODEL_TIMEOUT':
            return 'timeout';
        // try-again only, no advice to rephrase (Product 2026-10-13): a cut-off or empty reply is not
        // evidence the description was thin
        case 'GENERATE_ERROR_REASON_MODEL_TRUNCATED':
        case 'GENERATE_ERROR_REASON_MODEL_EMPTY':
            return 'tryAgain';
        // the only reasons allowed to suggest rephrasing
        case 'GENERATE_ERROR_REASON_REPLY_UNUSABLE':
        case 'GENERATE_ERROR_REASON_CONFIG_INVALID':
            return 'rephrase';
        case 'GENERATE_ERROR_REASON_DESCRIPTION_REQUIRED':
            return 'descriptionRequired';
        case 'GENERATE_ERROR_REASON_NOT_CONFIGURED':
        case 'GENERATE_ERROR_REASON_MODEL_UNAVAILABLE':
            return 'unavailable';
        // QUOTA_EXCEEDED is reserved (the producer does not emit it); Product: when emitted it reuses
        // the existing limit copy, not a new line — until then it falls to the fail-closed generic.
        default:
            return 'generic';
    }
}
/**
 * Drains a GenerateFromDescription chunk stream (oneof delta | finalAgent).
 * Throws if the stream ends without a finalAgent — a draftless generation is
 * a failed generation, never silently empty.
 */
export async function accumulateGenerate(chunks, onDelta, onStage) {
    let narration = '';
    let agent = null;
    let stage;
    for await (const chunk of chunks) {
        if (chunk.delta) {
            narration += chunk.delta;
            onDelta?.(narration);
        }
        const next = draftStage(chunk.progress);
        if (next && (!stage || STAGE_RANK[next] > STAGE_RANK[stage])) {
            stage = next;
            onStage?.(stage);
        }
        if (chunk.finalAgent)
            agent = chunk.finalAgent;
        if (chunk.error) {
            // terminal oneof arm — the stream ends after it; without this throw a
            // generation failure is indistinguishable from a truncated stream and
            // the create screen hangs on «Готовим черновик…» (web!13 fidelity
            // review, note 3533630439)
            throw new GenerateError(chunk.error, chunk.errorReason);
        }
    }
    if (!agent)
        throw new Error('generation stream ended without a final agent');
    return { narration, agent };
}
//# sourceMappingURL=generate.js.map